module.exports = __webpack_public_path__ + "img/icon-header-user-stat.db93ed45.svg";